"use client";

import { c as _c } from "react/compiler-runtime";
import IdentitySearch, { IdentitySearchSize } from "@/components/utils/input/identity/IdentitySearch";
import type { SelectableIdentityOption } from "@/components/utils/input/profile-search/getSelectableIdentity";
import { ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted } from "@/generated/models/ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted";
interface CreateDropIdentityPickerContentProps {
  readonly mode: ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted;
  readonly selectedIdentity: SelectableIdentityOption | null;
  readonly disabled: boolean;
  readonly errorMessage: string | null;
  readonly autoFocus?: boolean | undefined;
  readonly onSelect: (selection: SelectableIdentityOption) => void;
}
const getHelperText = (mode: ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted) => {
  switch (mode) {
    case ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted.OnlyOthers:
      return "Search for someone else to nominate.";
    case ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted.Everyone:
      return "Search for the identity you want to nominate.";
    case ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted.OnlyMyself:
      return "Your identity will be used automatically.";
  }
};
export default function CreateDropIdentityPickerContent(t0) {
  const $ = _c(21);
  const {
    mode,
    selectedIdentity,
    disabled,
    errorMessage,
    autoFocus: t1,
    onSelect
  } = t0;
  const autoFocus = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== disabled || $[1] !== onSelect) {
    t2 = disabled ? _temp : selection => {
      if (selection) {
        onSelect(selection);
      }
    };
    $[0] = disabled;
    $[1] = onSelect;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSelectionChange = t2;
  let t3;
  if ($[3] !== mode) {
    t3 = getHelperText(mode);
    $[3] = mode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p className="tw-mb-6 tw-text-sm tw-font-normal tw-text-iron-400">{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = selectedIdentity?.value ?? null;
  const t6 = selectedIdentity?.label ?? null;
  const t7 = !!errorMessage;
  let t8;
  if ($[7] !== autoFocus || $[8] !== disabled || $[9] !== errorMessage || $[10] !== onSelectionChange || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <IdentitySearch identity={t5} selectedDisplayValue={t6} setIdentity={_temp2} onSelectionChange={onSelectionChange} label="Search identity" size={IdentitySearchSize.MD} autoFocus={autoFocus} clearable={false} disabled={disabled} dropdownListClassName="tw-max-h-[50vh] md:tw-max-h-96 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300" error={t7} errorMessage={errorMessage} />;
    $[7] = autoFocus;
    $[8] = disabled;
    $[9] = errorMessage;
    $[10] = onSelectionChange;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== disabled) {
    t9 = disabled && <p className="tw-mb-0 tw-mt-3 tw-text-xs tw-font-medium tw-text-iron-500">Identity selection is disabled while the drop is submitting.</p>;
    $[15] = disabled;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t8 || $[19] !== t9) {
    t10 = <>{t4}{t8}{t9}</>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp2() {}
function _temp() {}